import { useState } from 'react';
import { useAuthStore } from '@/shared/stores/auth';
import { Icon } from './Icon';

/**
 * כפתור העתקת הקישור לפורטל ההקלטות של המרכזייה.
 *
 * הקישור הוא פר-דייר (הסלאג בנתיב הוא מה שתוחם את החיפוש לעסק אחד), ולכן
 * הוא נבנה מ-tenantSlug של המשתמש המחובר. מוצג רק כשהפיצ'ר דלוק לדייר —
 * הפורטל כבוי כברירת מחדל.
 */
export function PortalLinkButton() {
  const tenant = useAuthStore((s) => s.tenant);
  const [copied, setCopied] = useState(false);

  if (!tenant?.slug || !tenant.recordings_portal) {
    return null;
  }

  const url = `${window.location.origin}/p/${tenant.slug}/recordings`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // דפדפן ללא הרשאת clipboard (או הקשר לא-מאובטח) — נופלים לבחירה
      // ידנית כדי שהמשתמש עדיין יוכל להעתיק.
      window.prompt('העתק את הקישור:', url);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <button
      type="button"
      className="btn ghost"
      onClick={() => void copy()}
      title={`קישור לפורטל ההקלטות של הלקוחות — ${url}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 'var(--t-xs)' }}
    >
      <Icon name={copied ? 'check' : 'copy'} size={14} />
      {copied ? 'הקישור הועתק' : 'קישור לפורטל ההקלטות'}
    </button>
  );
}
